import React from 'react';

import Job from '../Components/Job';

const BehaviorTherapist = () => <Job title="therapist" />

export default BehaviorTherapist;
